import styled from 'styled-components';
import textStyle from './textStyle';

const P = styled.p`${textStyle};`;

export default P;
